module.exports = __webpack_public_path__ + "img/img61.0e9eee50.svg";